import React, {
  type MouseEvent,
  type ReactNode,
  type FunctionComponent,
  type JSX,
} from 'react';

export type LinkWrapperProps = {
  href: HTMLAnchorElement['href'];
  className?: HTMLAnchorElement['className'];
  target?: HTMLAnchorElement['target'];
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  dynamicQueryParamsToIgnore?: string[];
  prefetch?: boolean;
  scroll?: boolean;
  children: ReactNode;
  asElement?: FunctionComponent<{ children: ReactNode }>;
};

export type LinkWrapper = (props: LinkWrapperProps) => JSX.Element | null;

const DefaultLinkWrapper: LinkWrapper = ({
  href,
  className,
  target,
  onClick,
  children,
}) => (
  <a href={href} className={className} target={target} onClick={onClick}>
    {children}
  </a>
);

export default DefaultLinkWrapper;
